import React from 'react';
import {
  Box,
  Flex,
  Heading,
  Text,
  Spinner,
  Card,
  CardHeader,
  CardBody,
  HStack,
  Button,
  Badge,
  List,
  ListItem,
  Icon,
  useColorModeValue,
} from '@chakra-ui/react';
import { FiHelpCircle } from 'react-icons/fi';
import { MdOutlineAutoAwesome } from 'react-icons/md';

/**
 * FaqPopulares - Component for displaying popular FAQ entries
 * 
 * @param {Object} props - Component props
 * @param {Array} props.faqs - Array of FAQ objects
 * @param {boolean} props.isLoading - Loading state
 */
const FaqPopulares = ({ faqs, isLoading }) => {
  const cardBg = useColorModeValue('white', 'gray.700');
  const lightBg = useColorModeValue('gray.50', 'gray.600');

  return (
    <Card bg={cardBg} boxShadow="md">
      <CardHeader pb={2}>
        <Flex align="center">
          <Icon as={FiHelpCircle} mr={2} />
          <Heading size="md">FAQ Mais Acessados</Heading>
        </Flex>
      </CardHeader>
      <CardBody>
        {isLoading ? (
          <Flex justify="center" py={6}>
            <Spinner />
          </Flex>
        ) : (
          <List spacing={3}>
            {faqs.map((faq, index) => (
              <ListItem key={index}>
                <Flex justify="space-between" align="center">
                  <HStack>
                    <Box
                      w="24px"
                      h="24px"
                      borderRadius="full"
                      bg={lightBg}
                      display="flex"
                      alignItems="center"
                      justifyContent="center"
                      fontWeight="bold"
                      fontSize="sm"
                    >
                      {index + 1}
                    </Box>
                    <Text fontWeight="medium">{faq.pergunta}</Text>
                  </HStack>
                  <HStack spacing={4}>
                    <Badge colorScheme="blue" variant="outline">
                      {faq.acessos} acessos
                    </Badge>
                    <Badge 
                      colorScheme={faq.taxaResolucao > 90 ? 'green' : 'yellow'} 
                      variant="subtle"
                    >
                      {faq.taxaResolucao}% resolução
                    </Badge>
                  </HStack>
                </Flex>
              </ListItem>
            ))}
          </List>
        )}
        <Flex justify="center" mt={4}>
          <Button 
            leftIcon={<MdOutlineAutoAwesome />} 
            colorScheme="yellow" 
            variant="outline" 
            size="sm"
          >
            Gerenciar Base de Conhecimento
          </Button>
        </Flex>
      </CardBody>
    </Card>
  );
};

export default FaqPopulares;